/**
 * Comprehensive list of universities and colleges in Ho Chi Minh City
 * with verified coordinates for both headquarters (HQ) and branches.
 *
 * Coordinates are pre-verified and stored statically so the
 * UniversitySearchPage can display pins instantly without geocoding.
 * If a university has multiple campuses, the `branches` array contains
 * additional locations.
 *
 * All coordinates use WGS84 (lat, lng).
 */
const UNIVERSITIES = [
  // ===== Universities =====
  {
    id: 'hcmut',
    name: 'Ho Chi Minh City University of Technology (HCMUT)',
    nameVi: 'Đại học Bách Khoa TP.HCM',
    address: '268 Lý Thường Kiệt, Quận 10, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7626,
    lng: 106.6604,
    branches: [
      {
        name: 'HCMUT - Thu Duc Campus',
        nameVi: 'Đại học Bách Khoa TP.HCM (Cơ sở 2 - Thủ Đức)',
        address: '470 Trần Đại Nghĩa, Khu phố 6, Phường Linh Trung, Thành phố Thủ Đức, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.8795,
        lng: 106.8097,
      },
    ],
  },
  {
    id: 'hcmus',
    name: 'University of Science (VNU-HCM)',
    nameVi: 'Đại học Khoa học Tự nhiên TP.HCM',
    address: '227 Nguyễn Văn Cừ, Quận 5, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7622,
    lng: 106.6822,
    branches: [
      {
        name: 'University of Science - VNU Campus',
        nameVi: 'Đại học Khoa học Tự nhiên TP.HCM (Cơ sở 2 - Linh Trung)',
        address: 'Khu phố 6, Phường Linh Trung, Thành phố Thủ Đức, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.8693,
        lng: 106.8057,
      },
    ],
  },
  {
    id: 'hcmussh',
    name: 'University of Social Sciences and Humanities (VNU-HCM)',
    nameVi: 'Đại học Khoa học Xã hội và Nhân văn TP.HCM',
    address: '10-12 Đinh Tiên Hoàng, Quận 1, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7770,
    lng: 106.7060,
    branches: [
      {
        name: 'USSH - VNU Campus',
        nameVi: 'Đại học KHXH&NV TP.HCM (Cơ sở 2 - Linh Trung)',
        address: 'Khu phố 6, Phường Linh Trung, Thành phố Thủ Đức, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.8710,
        lng: 106.8100,
      },
    ],
  },
  {
    id: 'ueh',
    name: 'University of Economics Ho Chi Minh City (UEH)',
    nameVi: 'Đại học Kinh tế TP.HCM',
    address: '279 Nguyễn Tri Phương, Quận 10, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7705,
    lng: 106.6710,
    branches: [
      {
        name: 'UEH - Nguyen Dinh Chieu Campus',
        nameVi: 'Đại học Kinh tế TP.HCM (Cơ sở 59C Nguyễn Đình Chiểu)',
        address: '59C Nguyễn Đình Chiểu, Quận 3, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.7715,
        lng: 106.6908,
      },
      {
        name: 'UEH - Pham Ngoc Thach Campus',
        nameVi: 'Đại học Kinh tế TP.HCM (Cơ sở 17 Phạm Ngọc Thạch)',
        address: '17 Phạm Ngọc Thạch, Quận 3, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.7710,
        lng: 106.6880,
      },
      {
        name: 'UEH - Vinh Vien Campus',
        nameVi: 'Đại học Kinh tế TP.HCM (Cơ sở 172 Vĩnh Viễn)',
        address: '172 Vĩnh Viễn, Quận 10, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.7550,
        lng: 106.6700,
      },
    ],
  },
  {
    id: 'iou',
    name: 'International University (VNU-HCM)',
    nameVi: 'Đại học Quốc tế TP.HCM',
    address: 'Khu phố 6, Phường Linh Trung, Thành phố Thủ Đức, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8784,
    lng: 106.8082,
  },
  {
    id: 'hcmutransport',
    name: 'Ho Chi Minh City University of Transport',
    nameVi: 'Đại học Giao thông Vận tải TP.HCM',
    address: '2 Nguyễn Văn Trỗi, Quận Phú Nhuận, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7950,
    lng: 106.6830,
    branches: [
      {
        name: 'HCMUTransport - Le Van Sy Campus',
        nameVi: 'Đại học Giao thông Vận tải TP.HCM (Cơ sở 292 Lê Văn Sỹ)',
        address: '292 Lê Văn Sỹ, Quận 3, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.7860,
        lng: 106.6740,
      },
    ],
  },
  {
    id: 'hcmuaf',
    name: 'Nong Lam University',
    nameVi: 'Đại học Nông Lâm TP.HCM',
    address: 'Khu phố 6, Phường Linh Trung, Thành phố Thủ Đức (Xa lộ Hà Nội), TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8688,
    lng: 106.7822,
  },
  {
    id: 'hcmup',
    name: 'Ho Chi Minh City University of Pedagogy',
    nameVi: 'Đại học Sư phạm TP.HCM',
    address: '280 An Dương Vương, Quận 5, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7520,
    lng: 106.6850,
  },
  {
    id: 'hcmute',
    name: 'Ho Chi Minh City University of Technical Education',
    nameVi: 'Đại học Sư phạm Kỹ thuật TP.HCM',
    address: '01 Võ Văn Ngân, Phường Linh Chiểu, Thành phố Thủ Đức, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8440,
    lng: 106.7720,
  },
  {
    id: 'hcmulaw',
    name: 'Ho Chi Minh City University of Law',
    nameVi: 'Đại học Luật TP.HCM',
    address: '02 Nguyễn Tất Thành, Quận 4, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7480,
    lng: 106.7000,
    branches: [
      {
        name: 'HCMULAW - Long Thanh My Campus',
        nameVi: 'Đại học Luật TP.HCM (Cơ sở 204 Nguyễn Văn Tăng)',
        address: '204 Nguyễn Văn Tăng, Phường Long Thạnh Mỹ, Thành phố Thủ Đức, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.8390,
        lng: 106.7970,
      },
    ],
  },
  {
    id: 'rmit',
    name: 'RMIT University Vietnam',
    nameVi: 'Đại học RMIT Việt Nam',
    address: '702 Nguyễn Văn Linh, Quận 7, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7290,
    lng: 106.6960,
  },
  {
    id: 'hutech',
    name: 'HUTECH University',
    nameVi: 'Đại học Công nghệ TP.HCM (HUTECH)',
    address: '475A Điện Biên Phủ, Quận Bình Thạnh, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8110,
    lng: 106.7120,
    branches: [
      {
        name: 'HUTECH - Ung Van Khiem Campus',
        nameVi: 'HUTECH (Cơ sở Ung Văn Khiêm)',
        address: '23/2 Ung Văn Khiêm, Quận Bình Thạnh, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.8080,
        lng: 106.7150,
      },
      {
        name: 'HUTECH - Tan Phu Campus',
        nameVi: 'HUTECH (Cơ sở 50 Dương Bá Trạc)',
        address: '50 Dương Bá Trạc, Quận Tân Phú, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.7920,
        lng: 106.6540,
      },
    ],
  },
  {
    id: 'fen',
    name: 'FPT University',
    nameVi: 'Đại học FPT',
    address: 'Lô E2A-7, Đường D1, Khu Công nghệ cao, Quận 9 (Thành phố Thủ Đức), TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8420,
    lng: 106.8010,
  },
  {
    id: 'tueba',
    name: 'Hong Bang International University',
    nameVi: 'Đại học Quốc tế Hồng Bàng',
    address: '215 Điện Biên Phủ, Quận Bình Thạnh, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8090,
    lng: 106.7160,
  },
  {
    id: 'vanlang',
    name: 'Van Lang University',
    nameVi: 'Đại học Văn Lang',
    address: '69/68 Đặng Thùy Trâm, Quận Bình Thạnh, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8060,
    lng: 106.7120,
    branches: [
      {
        name: 'Van Lang - Nguyen Khac Nhu Campus',
        nameVi: 'Đại học Văn Lang (Cơ sở 45 Nguyễn Khắc Nhu)',
        address: '45 Nguyễn Khắc Nhu, Quận 1, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.7730,
        lng: 106.7000,
      },
      {
        name: 'Van Lang - Phan Van Tri Campus',
        nameVi: 'Đại học Văn Lang (Cơ sở 233A Phan Văn Trị)',
        address: '233A Phan Văn Trị, Quận 5, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.7550,
        lng: 106.6880,
      },
    ],
  },
  {
    id: 'tonducthang',
    name: 'Ton Duc Thang University',
    nameVi: 'Đại học Tôn Đức Thắng',
    address: '19 Nguyễn Hữu Thọ, Quận 7, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7320,
    lng: 106.6990,
  },
  {
    id: 'gialong',
    name: 'University of Foreign Languages - Information Technology',
    nameVi: 'Đại học Ngoại ngữ - Tin học TP.HCM (HUFLIT)',
    address: '828 Sư Vạn Hạnh, Quận 10, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7740,
    lng: 106.6690,
  },
  {
    id: 'saigon',
    name: 'Saigon University',
    nameVi: 'Đại học Sài Gòn',
    address: '273 An Dương Vương, Quận 5, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7520,
    lng: 106.6890,
    branches: [
      {
        name: 'Saigon University - Pham Ngu Lao Campus',
        nameVi: 'Đại học Sài Gòn (Cơ sở 105 Bà Huyện Thanh Quan)',
        address: '105 Bà Huyện Thanh Quan, Quận 3, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.7850,
        lng: 106.6900,
      },
    ],
  },
  {
    id: 'cntp',
    name: 'Ho Chi Minh City University of Food Industry',
    nameVi: 'Đại học Công nghiệp Thực phẩm TP.HCM',
    address: '140 Lê Trọng Tấn, Quận Tân Phú, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7960,
    lng: 106.6290,
    branches: [
      {
        name: 'HUFI - Sino Medical Campus',
        nameVi: 'Đại học Công nghiệp Thực phẩm TP.HCM (Cơ sở 12 Tăng Nhơn Phú)',
        address: '12 Tăng Nhơn Phú, Thành phố Thủ Đức, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.8380,
        lng: 106.7790,
      },
    ],
  },
  {
    id: 'cn4',
    name: 'Industrial University of Ho Chi Minh City',
    nameVi: 'Đại học Công nghiệp TP.HCM',
    address: '12 Nguyễn Văn Bảo, Quận Gò Vấp, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8220,
    lng: 106.6690,
    branches: [
      {
        name: 'IUH - Chau Van Lien Campus',
        nameVi: 'Đại học Công nghiệp TP.HCM (Cơ sở 12 Châu Văn Liêm)',
        address: '12 Châu Văn Liêm, Quận 5, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.7590,
        lng: 106.7000,
      },
      {
        name: 'IUH - Nguyen Van Cu Campus',
        nameVi: 'Đại học Công nghiệp TP.HCM (Cơ sở 16B1 Nguyễn Văn Cừ)',
        address: '16B1 Nguyễn Văn Cừ, Quận 5, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.7530,
        lng: 106.6850,
      },
    ],
  },
  {
    id: 'banking',
    name: 'Ho Chi Minh University of Banking',
    nameVi: 'Đại học Ngân hàng TP.HCM',
    address: '56 Hoàng Diệu 2, Phường Linh Chiểu, Thành phố Thủ Đức, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8508,
    lng: 106.7645,
    branches: [
      {
        name: 'HUB - Ham Nghi Campus',
        nameVi: 'Đại học Ngân hàng TP.HCM (Cơ sở 39 Hàm Nghi)',
        address: '39 Hàm Nghi, Quận 1, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.7760,
        lng: 106.7040,
      },
    ],
  },
  {
    id: 'finance',
    name: 'University of Finance - Marketing',
    nameVi: 'Đại học Tài chính - Marketing (UFM)',
    address: '2/4 Trần Xuân Soạn, Quận 7, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7420,
    lng: 106.6870,
    branches: [
      {
        name: 'UFM - Nguyen Kiem Campus',
        nameVi: 'Đại học Tài chính - Marketing (Cơ sở 778 Nguyễn Kiệm)',
        address: '778 Nguyễn Kiệm, Quận Gò Vấp, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.8120,
        lng: 106.6760,
      },
      {
        name: 'UFM - Xom Chieu Campus',
        nameVi: 'Đại học Tài chính - Marketing (Cơ sở 110 Xóm Chiếu)',
        address: '110 Xóm Chiếu, Quận 4, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.7580,
        lng: 106.7040,
      },
    ],
  },
  {
    id: 'medicine',
    name: 'University of Medicine and Pharmacy at HCMC',
    nameVi: 'Đại học Y Dược TP.HCM',
    address: '217 An Dương Vương, Quận 5, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7540,
    lng: 106.6830,
    branches: [
      {
        name: 'Faculty of Pharmacy - UMP',
        nameVi: 'Đại học Y Dược TP.HCM (Khoa Dược - 41 Đinh Tiên Hoàng)',
        address: '41 Đinh Tiên Hoàng, Quận 1, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.7770,
        lng: 106.7050,
      },
    ],
  },
  {
    id: 'pharmacity',
    name: 'University of Medicine and Pharmacy - Faculty of Pharmacy Campus',
    nameVi: 'Khoa Dược - Đại học Y Dược TP.HCM',
    address: '41 Đinh Tiên Hoàng, Quận 1, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7770,
    lng: 106.7050,
  },
  {
    id: 'architecture',
    name: 'Ho Chi Minh City University of Architecture',
    nameVi: 'Đại học Kiến trúc TP.HCM',
    address: '196 Pasteur, Quận 3, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7780,
    lng: 106.6900,
  },
  {
    id: 'culture',
    name: 'Ho Chi Minh City University of Culture',
    nameVi: 'Đại học Văn hóa TP.HCM',
    address: '51 Quốc Hương, Quận 2, Thành phố Thủ Đức, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7850,
    lng: 106.7150,
  },
  {
    id: 'sport',
    name: 'Ho Chi Minh City University of Sport',
    nameVi: 'Đại học Thể dục Thể thao TP.HCM',
    address: '639 Nguyễn Trãi, Quận 5, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7620,
    lng: 106.6590,
  },
  {
    id: 'fisheries',
    name: 'Ho Chi Minh City Fisheries University',
    nameVi: 'Đại học Thủy sản TP.HCM (Phân hiệu)',
    address: '182 Lê Duẩn, Quận 1, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7820,
    lng: 106.7050,
  },
  {
    id: 'hcmcmedicine',
    name: 'Pham Ngoc Thach University of Medicine',
    nameVi: 'Đại học Y Khoa Phạm Ngọc Thạch',
    address: '86/2 Thành Thái, Quận 10, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7690,
    lng: 106.6780,
  },
  {
    id: 'nguyenhuulaw',
    name: 'Ho Chi Minh City University of Economics and Law',
    nameVi: 'Đại học Kinh tế - Luật TP.HCM (UEL)',
    address: 'Khu phố 6, Phường Linh Xuân, Thành phố Thủ Đức, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8990,
    lng: 106.7950,
    branches: [
      {
        name: 'UEL - Nguyen Kiem Campus',
        nameVi: 'Đại học Kinh tế - Luật TP.HCM (Cơ sở 669 Nguyễn Kiệm)',
        address: '669 Nguyễn Kiệm, Quận Gò Vấp, TP. Hồ Chí Minh, Việt Nam',
        lat: 10.8120,
        lng: 106.6750,
      },
    ],
  },

  // ===== Colleges =====
  {
    id: 'caothang',
    name: 'Cao Thang Technical College',
    nameVi: 'Cao đẳng Kỹ thuật Cao Thắng',
    address: '65 Huỳnh Thúc Kháng, Quận 1, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7705,
    lng: 106.6940,
  },
  {
    id: 'cdkinhte',
    name: 'Ho Chi Minh City College of Economics',
    nameVi: 'Cao đẳng Kinh tế TP.HCM',
    address: '17 Vũ Văn Tần, Quận 3, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7760,
    lng: 106.6900,
  },
  {
    id: 'cdcongthuong',
    name: 'Ho Chi Minh City College of Industry and Trade',
    nameVi: 'Cao đẳng Công Thương TP.HCM',
    address: '20 Tăng Nhơn Phú, Thành phố Thủ Đức, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8360,
    lng: 106.7790,
  },
  {
    id: 'cdytetc',
    name: 'Ho Chi Minh City College of Health',
    nameVi: 'Cao đẳng Y tế TP.HCM',
    address: '201 Bis Hoàng Văn Thụ, Quận Phú Nhuận, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7950,
    lng: 106.6790,
  },
  {
    id: 'cdsaigon',
    name: 'Saigon College',
    nameVi: 'Cao đẳng Sài Gòn',
    address: '236 Hoàng Quốc Việt, Quận Bình Thạnh, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8290,
    lng: 106.7100,
  },
  {
    id: 'cdgiaothongtw2',
    name: 'College of Transport Central 2',
    nameVi: 'Cao đẳng Giao thông Vận tải Trung ương 2',
    address: '256 Nguyễn Văn Linh, Quận 7, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7300,
    lng: 106.6980,
  },
  {
    id: 'cdcntthcm',
    name: 'Ho Chi Minh City College of Information Technology',
    nameVi: 'Cao đẳng Công nghệ Thông tin TP.HCM',
    address: '12 Trịnh Đình Thảo, Quận Tân Phú, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7920,
    lng: 106.6450,
  },
  {
    id: 'cdbachkhosaigon',
    name: 'Saigon Polytechnic College',
    nameVi: 'Cao đẳng Bách Khoa Sài Gòn',
    address: '120 Hòa Bình, Quận Tân Phú, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7900,
    lng: 106.6490,
  },
  {
    id: 'cddaivietsaigon',
    name: 'Dai Viet Saigon College',
    nameVi: 'Cao đẳng Đại Việt Sài Gòn',
    address: '202 Nguyễn Văn Lượng, Quận Gò Vấp, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8170,
    lng: 106.6740,
  },
  {
    id: 'cdnguyentruongto',
    name: 'Nguyen Truong To Technical College',
    nameVi: 'Cao đẳng Kỹ thuật Nguyễn Trường Tộ',
    address: '17A Cộng Hòa, Quận Tân Bình, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8040,
    lng: 106.6600,
  },
  {
    id: 'fptpolytechnic',
    name: 'FPT Polytechnic College',
    nameVi: 'Cao đẳng FPT Polytechnic',
    address: 'Lô E2A-7, Đường D1, Khu Công nghệ cao, Quận 9 (Thành phố Thủ Đức), TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8420,
    lng: 106.8010,
  },
  {
    id: 'cdspthcm',
    name: 'Central College of Pedagogy Ho Chi Minh City',
    nameVi: 'Cao đẳng Sư phạm Trung ương TP.HCM',
    address: '56 Nguyễn Đình Chiểu, Quận 1, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7770,
    lng: 106.6920,
  },
  {
    id: 'cdkent',
    name: 'Kent International College',
    nameVi: 'Cao đẳng Quốc tế Kent',
    address: '234 Nguyễn Văn Cừ, Quận 5, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7640,
    lng: 106.6810,
  },
  {
    id: 'cdnghehcm',
    name: 'Ho Chi Minh City Vocational College',
    nameVi: 'Cao đẳng Nghề TP.HCM',
    address: '5/3B Trần Hưng Đạo, Quận 5, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7560,
    lng: 106.6810,
  },
  {
    id: 'cdxaydung',
    name: 'Ho Chi Minh City College of Construction',
    nameVi: 'Cao đẳng Xây dựng TP.HCM',
    address: '160 Lê Quang Sung, Quận 6, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7460,
    lng: 106.6540,
  },
  {
    id: 'cdkinhtekythuat',
    name: 'Ho Chi Minh City College of Economics and Technology',
    nameVi: 'Cao đẳng Kinh tế Kỹ thuật TP.HCM',
    address: '168 Lê Thị Riêng, Quận 12, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8490,
    lng: 106.6330,
  },
  {
    id: 'cdvanhoanghethuat',
    name: 'Ho Chi Minh City College of Culture and Arts',
    nameVi: 'Cao đẳng Văn hóa Nghệ thuật TP.HCM',
    address: '371 Nguyễn Kiệm, Quận Gò Vấp, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8180,
    lng: 106.6850,
  },
  {
    id: 'cdcnthuongmai',
    name: 'College of Technology and Commerce',
    nameVi: 'Cao đẳng Công nghệ và Thương mại',
    address: '45 Nguyễn Văn Đậu, Quận Bình Thạnh, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7980,
    lng: 106.7060,
  },
  {
    id: 'cdviendong',
    name: 'Vien Dong College',
    nameVi: 'Cao đẳng Viễn Đông',
    address: '581 Lê Quang Định, Quận Bình Thạnh, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8190,
    lng: 106.6970,
  },
  {
    id: 'cdlytutrong',
    name: 'Ly Tu Trong Technical College',
    nameVi: 'Cao đẳng Kỹ thuật Lý Tự Trọng',
    address: '224 Lê Văn Sỹ, Quận 3, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7880,
    lng: 106.6730,
  },
  {
    id: 'cdngoaingucongnghe',
    name: 'Ho Chi Minh City College of Foreign Languages and Technology',
    nameVi: 'Cao đẳng Ngoại ngữ và Công nghệ TP.HCM',
    address: '155 Nguyễn Văn Trỗi, Quận Phú Nhuận, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7970,
    lng: 106.6840,
  },
  {
    id: 'cdktdoingoai',
    name: 'College of Foreign Economic Relations',
    nameVi: 'Cao đẳng Kinh tế Đối ngoại',
    address: '830/8 Sư Vạn Hạnh, Quận 10, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7740,
    lng: 106.6680,
  },
  {
    id: 'cdquoctesaigon',
    name: 'Saigon International College',
    nameVi: 'Cao đẳng Quốc tế Sài Gòn',
    address: '106 Mai Hắc Đế, Quận 1, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7850,
    lng: 106.7010,
  },
  {
    id: 'cdhoasen',
    name: 'Hoa Sen College',
    nameVi: 'Cao đẳng Hoa Sen',
    address: '08 Nguyễn Văn Tráng, Quận 1, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.7710,
    lng: 106.6910,
  },
  {
    id: 'cdcnttphcm',
    name: 'Ho Chi Minh City College of Technology and Management',
    nameVi: 'Cao đẳng Công nghệ và Quản lý TP.HCM',
    address: '236 Cộng Hòa, Quận Tân Bình, TP. Hồ Chí Minh, Việt Nam',
    lat: 10.8030,
    lng: 106.6630,
  },
];

export default UNIVERSITIES;